/**
 * Read more / Read less for rich-text `text` blocks.
 *
 * Enabled per block via the "Read more" checkbox in sections/rich-text.liquid,
 * which renders `data-read-more="<lines>"` on the block's `.rte` wrapper.
 * Everything after the Nth line break (a `<br>` or a paragraph end) is hidden
 * behind an inline toggle. Content stays in the DOM, so it is still indexed.
 */
(function () {
  function init(rte) {
    if (rte.dataset.readMoreReady) return;
    rte.dataset.readMoreReady = 'true';

    var lines = parseInt(rte.dataset.readMore, 10) || 1;
    var blocks = Array.prototype.slice.call(rte.children);
    var count = 0;
    var cutBlock = null;
    var cutBr = null;

    for (var i = 0; i < blocks.length && !cutBlock; i++) {
      var brs = blocks[i].querySelectorAll('br');
      for (var j = 0; j < brs.length; j++) {
        if (++count === lines) {
          cutBlock = blocks[i];
          cutBr = brs[j];
          break;
        }
      }
      if (!cutBlock && i < blocks.length - 1 && ++count === lines) {
        cutBlock = blocks[i];
      }
    }
    if (!cutBlock) return;

    var hidden = [];

    // Rest of the paragraph after the cut <br>, wrapped so it can be hidden.
    if (cutBr) {
      var rest = document.createElement('span');
      rest.className = 'rte-read-more__more';
      var node = cutBr;
      while (node) {
        var next = node.nextSibling;
        rest.appendChild(node);
        node = next;
      }
      cutBlock.appendChild(rest);
      hidden.push(rest);
    }

    // Every paragraph after the cut one.
    var after = blocks.slice(blocks.indexOf(cutBlock) + 1);
    hidden = hidden.concat(after);
    if (!hidden.length) return;

    var moreLabel = rte.dataset.readMoreLabel || 'Read more';
    var lessLabel = rte.dataset.readLessLabel || 'Read less';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'rte-read-more__toggle';
    toggle.setAttribute('aria-expanded', 'false');

    var lastBlock = blocks[blocks.length - 1];

    function setExpanded(expanded) {
      hidden.forEach(function (el) {
        el.hidden = !expanded;
      });
      toggle.textContent = expanded ? lessLabel : moreLabel;
      toggle.setAttribute('aria-expanded', String(expanded));
      // Collapsed: toggle sits right after the cut. Expanded: at the very end.
      if (expanded) {
        lastBlock.appendChild(toggle);
      } else if (cutBr) {
        cutBlock.insertBefore(toggle, hidden[0]);
      } else {
        cutBlock.appendChild(toggle);
      }
    }

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });
    setExpanded(false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.rte[data-read-more]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
